import OrderModel from "../models/OrderModel";
export default [
  new OrderModel("AOP943", 2190),
  new OrderModel("AOP780", 2190),
  new OrderModel("AOP808", 2190),
  new OrderModel("AOP900", 2190),
  new OrderModel("AOP129", 2190),
  new OrderModel("AOP112", 2190),
  new OrderModel("AOP311", 2190),
  new OrderModel("AOP233", 2190),
  new OrderModel("AOP451", 2190),
  new OrderModel("AOP343", 2190),
  new OrderModel("AOP333", 2190),
];
